import React, { ReactNode } from 'react';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import InfoIcon from '@mui/icons-material/Info';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Box, Collapse } from '@mui/material';
import MediaTypography from 'components/MediaTypography';
import AddFileButton from 'modules/Report/components/AddFileButton';

import useReportInfoBlockLogic from '@common/modules/Report/hooks/useItemLogic';

import ReportUploadFileModal from '../Modal';
import {
	StyledReportInfoBlockHeaderCollapseButton,
	StyledReportInfoBlockHeaderLink,
	StyledReportInfoBlockHeaderTitleWrap,
	StyledReportInfoBlockHeaderWrap,
	StyledReportInfoBlockTooltip,
	StyledReportInfoBlockWrap,
} from './styled';

interface PropsType {
	title: string;
	onAddFileClick?: (data: any) => void;
	toolTipText?: ReactNode;
	href?: string;
	children: ReactNode;
}

function ReportInfoBlock({ title, onAddFileClick, toolTipText, href, children }: PropsType) {
	const { isCollapsed, isModalOpen, handleModalOpen, handleToggleCollapse } =
		useReportInfoBlockLogic();

	return (
		<StyledReportInfoBlockWrap elevation={1}>
			<StyledReportInfoBlockHeaderWrap>
				<StyledReportInfoBlockHeaderTitleWrap>
					<MediaTypography variant="h4" lineClamp={{ default: 1 }}>
						{title}
					</MediaTypography>
					{toolTipText && (
						<StyledReportInfoBlockTooltip title={toolTipText} enterTouchDelay={0} arrow>
							<InfoIcon sx={{ fontSize: '24px' }} />
						</StyledReportInfoBlockTooltip>
					)}
				</StyledReportInfoBlockHeaderTitleWrap>
				{onAddFileClick && (
					<>
						<AddFileButton sx={{ flexShrink: 0 }} onClick={handleModalOpen(true)} />
						<ReportUploadFileModal
							open={isModalOpen}
							onClose={handleModalOpen(false)}
							handleSubmit={(data) => {
								onAddFileClick(data);
								handleModalOpen(false);
							}}
							initialValues={{ name: '', file: '', type: null }}
						/>
					</>
				)}
				{href ? (
					<StyledReportInfoBlockHeaderLink href={href}>
						<ArrowForwardIcon />
					</StyledReportInfoBlockHeaderLink>
				) : (
					<StyledReportInfoBlockHeaderCollapseButton onClick={handleToggleCollapse}>
						<KeyboardArrowUpIcon
							sx={{
								transform: isCollapsed ? 'rotate(180deg)' : 'rotate(0deg)',
								transition: 'all .3s',
							}}
						/>
					</StyledReportInfoBlockHeaderCollapseButton>
				)}
			</StyledReportInfoBlockHeaderWrap>
			<Collapse in={!isCollapsed} sx={{ width: '100%' }}>
				<Box sx={{ marginTop: '8px' }}>{children}</Box>
			</Collapse>
		</StyledReportInfoBlockWrap>
	);
}

export default ReportInfoBlock;
